uniformsService.$inject = ['apiBase', '$q', '$http', 'logErrorToBackendService']

function uniformsService (apiBase, $q, $http, logErrorToBackendService) {
  var endpointPath = apiBase + 'v3/uniform'

  function endpoint (endPath) {
    if (endPath) {
      return endpointPath + '/' + endPath
    } else {
      return endpointPath
    }
  }

  function get (uniformId) {
    var canceler = $q.defer()

    var promise = $http({
      url: endpoint('forms/' + uniformId),
      method: 'GET',
      cache: false,
      timeout: canceler.promise
    })
      .catch(function (err) {
        logErrorToBackendService.error(JSON.stringify({ err: err }))
        throw err
      })

    return {
      promise: promise,
      canceler: canceler
    }
  }

  function create (data) {
    var canceler = $q.defer()

    var promise = $http({
      url: endpoint('forms'),
      method: 'POST',
      timeout: canceler.promise,
      data: data
    })
      .catch(function (err) {
        logErrorToBackendService.error(JSON.stringify({ err: err }))
        throw err
      })

    return {
      promise: promise,
      canceler: canceler
    }
  }

  function update (opportunityId, data) {
    var canceler = $q.defer()

    var promise = $http({
      url: endpoint('forms/' + opportunityId),
      method: 'PUT',
      timeout: canceler.promise,
      data: data
    })
      .catch(function (err) {
        logErrorToBackendService.error(JSON.stringify({ err: err }))
        throw err
      })

    return {
      promise: promise,
      canceler: canceler
    }
  }

  function submit (opportunityId) {
    var canceler = $q.defer()

    var promise = $http({
      url: endpoint('forms/' + opportunityId + '/submit'),
      method: 'POST',
      timeout: canceler.promise
    })
      .catch(function (err) {
        logErrorToBackendService.error(JSON.stringify({ err: err }))
        throw err
      })

    return {
      promise: promise,
      canceler: canceler
    }
  }

  return {
    get: get,
    create: create,
    update: update,
    submit: submit
  }
}

module.exports = uniformsService
